import React from 'react';
import EchoMeasurementTable from '../../../../components/EchoMeasurementTable';

/**
 * Report-side Echo Measurements tab wrapper (F7).
 * Mirrors the patientMeasurements wrapper pattern: receives ReportData and renders
 * the structured measurement table, scoped to that report + study.
 */
const EchoMeasurements = ({ ReportData }: { ReportData?: any }) => {
  return (
    <EchoMeasurementTable
      reportId={ReportData?._id}
      studyInstanceUID={ReportData?.studyInstanceUID}
      status={ReportData?.status}
      sex={ReportData?.sex}
    />
  );
};

export default EchoMeasurements;
